export default function InternalLinks() {
  const links = [
    {
      href: "/",
      title: "Accueil DF PRO",
      desc: "Découvrez tous nos services de réparation de fenêtre à Strasbourg et dans le Bas-Rhin.",
    },
    {
      href: "/#zones",
      title: "Zones d'intervention",
      desc: "Nous intervenons dans toute l'agglomération de Strasbourg, à Haguenau, Schiltigheim, Illkirch et bien d'autres communes.",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Pages connexes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="group bg-rose-50 rounded-2xl p-5 md:p-6 border border-rose-100 hover:border-coral/30 transition-colors"
              >
                <h3 className="font-semibold text-base md:text-lg text-plum-dark mb-2 group-hover:text-coral transition-colors">
                  {link.title}
                </h3>
                <p className="text-sm md:text-base text-plum-dark/70 leading-relaxed">
                  {link.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-coral mt-3">
                  En savoir plus
                  <i className="ri-arrow-right-line" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}